import { toast } from 'react-toastify';

const toastError = (message: string, options?: object): void => {
  toast.error(message, {
    position: 'top-center',
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    ...options,
  });
};

export default toastError;
